import * as React from "react";
import styled from "styled-components";

import CompanyValuesPicker, { CompanyValuesPickerModels } from "./CompanyValuesPicker";
import CompanyValuesSorter, { CompanyValuesSorterModels } from "./CompanyValuesSorter";
import CompanyValuesSelectorActions from "./CompanyValuesSelectorActions";
import WithLocale from "../../common/components/WithLocale";

type CompanyValueFeature = WtdModels.Union<
  CompanyValuesPickerModels["CompanyValueFeature"],
  CompanyValuesSorterModels["CompanyValueFeature"]
>;

type CategorizedCompanyValueFeature = CompanyValuesPickerModels["CategorizedCompanyValueFeature"];

export interface CompanyValuesSelectorModels {
  CompanyValueFeature: CompanyValueFeature;
  CategorizedCompanyValueFeature: CategorizedCompanyValueFeature;
}

interface Props {
  features: CategorizedCompanyValueFeature[];
  companyValueFeatures: CompanyValueFeature[];
  selectedFeatures: string[];
  onChange(features: string[]): void;
  onSubmit(): void;
  onCancel(): void;
}

class CompanyValuesSelector extends React.PureComponent<Props> {
  public render() {
    const { features, companyValueFeatures, selectedFeatures, onChange, onSubmit, onCancel } = this.props;
    return (
      <WithLocale>
        {({ translate: t }) => (
          <Wrapper>
            <CompanyValuesPicker features={features} selectedFeatures={selectedFeatures} onChange={onChange} />
            <RightCol>
              <Heading>{t("company.values.message")}</Heading>
              <Para>{t("company.values.sub_message")}</Para>
              <SorterWrapper>
                <CompanyValuesSorter
                  selectedFeatures={selectedFeatures}
                  companyValueFeatures={companyValueFeatures}
                  onChange={features => {
                    this.props.onChange(features);
                  }}
                />
              </SorterWrapper>
              <CompanyValuesSelectorActions
                onSubmit={onSubmit}
                onCancel={onCancel}
                selectedCount={selectedFeatures.length}
              />
            </RightCol>
          </Wrapper>
        )}
      </WithLocale>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  height: 100%;
`;

const RightCol = styled.div`
  width: 325px;
  box-sizing: border-box;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const SorterWrapper = styled.div`
  padding: 12px;
`;

const Heading = styled.div`
  margin: 40px 30px 0;
  font-weight: 600;
  font-size: 21px;
  line-height: 1.43;
  color: rgba(36, 40, 42, 1);
`;

const Para = styled.div`
  margin: 5px 30px 10px;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.67;
  color: rgba(0, 0, 0, 0.27);
`;

export default CompanyValuesSelector;



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/CompanyValuesSelector.tsx